// Packages
import { createAsyncThunk } from '@reduxjs/toolkit';
// API
import { ClientLoginAPI } from 'api/endpoints';
// Interfaces and types
import {
  ICreateClientLoginRes,
  ICreateClientLoginBody,
  IUpdateClientLoginBodyWithParam,
  IGetClientLoginDetailsRes,
  IGetClientLoginsListRes,
} from 'types/clientLoginType';
import { IResMessage, TQueryParams, IErrorRes } from 'types/appTypes';

const getClientLoginsListAsync = createAsyncThunk<
  IGetClientLoginsListRes,
  TQueryParams,
  { rejectValue: IErrorRes }
>('clientLogins/getClientLoginsList', async (params: TQueryParams, { rejectWithValue }) => {
  try {
    return await ClientLoginAPI.getClientLoginsList(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const createClientLoginAsync = createAsyncThunk<
  ICreateClientLoginRes,
  ICreateClientLoginBody,
  { rejectValue: IErrorRes }
>(
  'clientLogins/createClientLogin',
  async (cred: ICreateClientLoginBody, { rejectWithValue }) => {
    try {
      return await ClientLoginAPI.createClientLogin(cred);
    } catch (error) {
      return rejectWithValue(error as IErrorRes);
    }
  },
);

const getClientLoginDetailsAsync = createAsyncThunk<
  IGetClientLoginDetailsRes,
  number,
  { rejectValue: IErrorRes }
>('clientLogins/getClientLoginDetails', async (id: number, { rejectWithValue }) => {
  try {
    return await ClientLoginAPI.getClientLoginDetails(id);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const updateClientLoginAsync = createAsyncThunk<
  IResMessage,
  IUpdateClientLoginBodyWithParam,
  { rejectValue: IErrorRes }
>(
  'clientLogins/updateClientLogin',
  async (cred: IUpdateClientLoginBodyWithParam, { rejectWithValue }) => {
    try {
      return await ClientLoginAPI.updateClientLogin(cred);
    } catch (error) {
      return rejectWithValue(error as IErrorRes);
    }
  },
);

const deleteClientLoginAsync = createAsyncThunk<
  IResMessage,
  number,
  { rejectValue: IErrorRes }
>('clientLogins/deleteClientLogin', async (id: number, { rejectWithValue }) => {
  try {
    return await ClientLoginAPI.deleteClientLogin(id);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

export {
  getClientLoginsListAsync,
  createClientLoginAsync,
  getClientLoginDetailsAsync,
  updateClientLoginAsync,
  deleteClientLoginAsync,
};
